module.exports = __webpack_public_path__ + "img/blue_046.cbc86d18.png";